// @flow

import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import Settings, { SettingsEntry } from '../Model/Settings';

type Props = {
  settings: Settings,
  settingsKey: string,
};

@observer
export default class SettingsHtml extends React.Component<Props, void> {
  render() {
    const { props: { settings, settingsKey } } = this;
    const html = (settings.settings.get(settingsKey) || new SettingsEntry()).value;
    if (html) {
      return <div dangerouslySetInnerHTML={{ __html: html }} />;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/SettingsHtml.js